<template>
  <div style="padding: 15px 10px">
    <PointTitle>{{ item.title }}</PointTitle>
    <div class="margin10"></div>
    <div v-html="item.content"></div>
    <div class="margin10"></div>
    <PointTitle>适用范围</PointTitle>
    <div class="margin10"></div>
    <DiseaseTag type="pc" :list="tagList"></DiseaseTag>
  </div>
</template>

<script>
import PointTitle from "./pointtitle.vue";
export default {
  components: {
    PointTitle,
  },
  props: {
    item: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    tagList() {
      return this.item.areaApplication.split(",");
    },
  },
};
</script>

<style>
</style>